export enum BulkActivateShiftTemplateFormFieldsEnum {
  startDate = "startDate",
}
